import React from 'react'

const ItemDetailContainer = () => {
  return (
    <div>
      
    </div>
  )
}

export default ItemDetailContainer
